import {Mutation, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';



@Injectable({
    providedIn: 'root'
})
export class SaveBlockQuery extends Mutation<any> {
    document = gql`
        mutation saveTurbineLogbookEntry(
            $level: String
            $input: [TurbineLogbookEntryInput]
            $inputEvent: [TurbineLogbookEventInput]
            $processAssignment: ProcessAssignment
            $originalBlocks: [TurbineLogbookEntryInput]
            $startTS: Float
            $endTS: Float
        ) {
            saveTurbineLogbookEntry(
                level: $level
                input: $input
                inputEvent: $inputEvent
                processAssignment: $processAssignment
                originalBlocks: $originalBlocks
                startTS: $startTS
                endTS: $endTS
            )
        }
    `;
}
